var map = {
	"./appstore.png": 342,
	"./flag_gb.png": 44,
	"./flag_hu.png": 45,
	"./home-phone-cropped-1.png": 346,
	"./home_bg_patient.png": 347,
	"./logo_icon_grey.png": 213,
	"./pattern.png": 358,
	"./pattern_fixed_transparent.png": 359,
	"./placeholder.png": 365,
	"./playstore.png": 366,
	"./pulmoment_wide.png": 215
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 218;



//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.png$
// module id = 218
// module chunks = 2